"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.planDetailsSlice = exports.fetchCustomerOffers = exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../api");
var _extraReducers;
var initialState = {
  currentPlan: null,
  loading: false,
  error: null
};
var fetchCustomerOffers = (0, _toolkit.createAsyncThunk)('plan/fetchCustomerOffers', /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_, _ref) {
    var rejectWithValue, _yield$getCustomerOff, items;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          rejectWithValue = _ref.rejectWithValue;
          _context.prev = 1;
          _context.next = 4;
          return (0, _api.getCustomerOffers)();
        case 4:
          _yield$getCustomerOff = _context.sent;
          items = _yield$getCustomerOff.items;
          return _context.abrupt("return", items);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", rejectWithValue(_context.t0.message));
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 9]]);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
exports.fetchCustomerOffers = fetchCustomerOffers;
var planDetailsSlice = (0, _toolkit.createSlice)({
  name: 'plan',
  initialState: initialState,
  reducers: {},
  extraReducers: (_extraReducers = {}, (0, _defineProperty2.default)(_extraReducers, fetchCustomerOffers.pending, function (state) {
    state.loading = true;
  }), (0, _defineProperty2.default)(_extraReducers, fetchCustomerOffers.fulfilled, function (state, _ref3) {
    var payload = _ref3.payload;
    state.loading = false;
    state.currentPlan = payload;
  }), (0, _defineProperty2.default)(_extraReducers, fetchCustomerOffers.rejected, function (state, _ref4) {
    var payload = _ref4.payload;
    state.loading = false;
    state.error = payload;
  }), _extraReducers)
});
exports.planDetailsSlice = planDetailsSlice;
var _default = planDetailsSlice.reducer;
exports.default = _default;